import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, isRef as _isRef, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cc1977f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "home_box" }

import { onMounted, reactive, ref, watch } from "vue";
import { api_cw_get_finance_list, api_cw_balance_inquiry, api_cw_pay_check } from '@/api/home';
import { message, type TableColumnsType } from 'ant-design-vue';

import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import type { Dayjs } from 'dayjs';

import router from "@/router";



type RangeValue = [Dayjs, Dayjs];

export default /*#__PURE__*/_defineComponent({
  __name: 'balance_enquiry',
  setup(__props) {

console.log(locale);

const value1 = ref<RangeValue>();
let current = ref<number>(1)
let user: any = localStorage.getItem('user') || sessionStorage.getItem('user');
user = JSON.parse(user);

let status = ref<string>('')


watch(value1, (newValue, oldValue) => {
    if (newValue === null) {
        list.value = [];
        current.value = 1;
        total.value = 1;
    }
})

let packageNo = ref('');

onMounted(() => {
    console.log('组件加载');
    // api_cw_balance_inquiryFun();
    finishFun('');
});

const handleChange = (e: any) => {
    console.log(e);
}
const focus = (e: any) => {
    console.log(e);
}
const paginationChange = (e: number) => {
    current.value = e;
    finishFun('');
}


let date = ref<number[]>([]);

let usableBalance = ref(0);
let balance = ref(0);
let lastDayBalance = ref(0);

const open = ref<boolean>(false);


const showModal = () => {
    open.value = true;
};

const handleOk = (e: MouseEvent) => {
    console.log(e);
    open.value = false;
};













const api_cw_balance_inquiryFun = async () => {
    let data: any = await api_cw_balance_inquiry(user.payAccNo, user.openid);
    usableBalance.value = data.usableBalance
    balance.value = data.balance
    lastDayBalance.value = data.lastDayBalance
    console.log(data);

}

const columns: TableColumnsType = [
    { title: '转账账号', width: 100, dataIndex: 'recAccNo' },
    { title: '开户名', width: 100, dataIndex: 'recAccName' },
    { title: '银行名称', width: 100, dataIndex: 'recBankName' },
    { title: '转账金额', width: 100, dataIndex: 'amount' },
    { title: '订单号', width: 100, dataIndex: 'packageNo' },
    { title: '操作时间', width: 100, dataIndex: 'time' },
    { title: '状态', width: 100, dataIndex: 'message' },
    { title: '操作', width: 100, dataIndex: 'Controls' }
];

const columnss: TableColumnsType = [
    { title: '转账账号', width: "30%", dataIndex: 'recAccNo' },
    { title: '转账金额', width: "15%", dataIndex: 'amount' },
    { title: '转账状态', width: "30%", dataIndex: 'desc' },
]

let list: any = ref([]);
let dataSource: any = ref([]);

let total: any = ref(1)
const finishFun = async (value: any) => {
    list.value = [];
    let up = {
        accNo: user.payAccNo,  //查询银行账号
        pageNo: current.value, //分页 （从1开始）
        beginDate: date.value[0] ? date.value[0] / 1000 : 0,  //开始时间
        endDate: date.value[1] ? date.value[1] / 1000 : 0, //结束时间
        openid: user.openid,
        status: status.value,
        packageNo: packageNo.value

    }
    let data: any = await api_cw_get_finance_list(up);
    if (data.error !== 0) {
        message.error('暂无数据！！！')
        return
    }
    total.value = data.total * 1;
    data.list.forEach((item: any) => {
        list.value.push(item);
    });
    packageNo.value = '';
}


let pickerChangeFun = (e: any) => {
    if (e === null) return
    if (date.value.length === 2) {
        date.value = []
    }
    for (let index = 0; index < e.length; index++) {
        const element = e[index].$d;
        date.value.push(Date.parse(element));
    }
}

const StatusQueryFun = async (item: any) => {
    console.log(item);
    dataSource.value = [];

    let up = {
        openid: user.openid,
        queryPacNo: item.packageNo
    }
    console.log(up);

    let data: any = await api_cw_pay_check(up);
    if (data.header.code === '000000') {
        open.value = true;
        data.body.details.forEach((item: any) => {

            let obj = {
                recAccNo: item.recAccNo,
                amount: item.amount / 100,
                desc: item.desc
            }
            dataSource.value.push(obj);
        });
        console.log(dataSource.value);
    }






}



return (_ctx: any,_cache: any) => {
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_descriptions, {
      bordered: "",
      size: "small",
      column: 2
    }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_space, {
          direction: "vertical",
          style: {"margin":"0 20px"}
        }),
        _createVNode(_component_a_form, { layout: "inline" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_range_picker, {
                  value: value1.value,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value1).value = $event)),
                  "show-time": { format: 'HH:mm' },
                  locale: _unref(locale),
                  format: "YYYY-MM-DD HH:mm",
                  onChange: _unref(pickerChangeFun)
                }, null, 8, ["value", "locale", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _unref(packageNo),
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_isRef(packageNo) ? (packageNo).value = $event : packageNo = $event)),
                  placeholder: "请输入订单号"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: _unref(status),
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_isRef(status) ? (status).value = $event : status = $event)),
                  style: {"width":"100px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "1" }, {
                      default: _withCtx(() => [
                        _createTextVNode("全部")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "2" }, {
                      default: _withCtx(() => [
                        _createTextVNode("成功")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: "3" }, {
                      default: _withCtx(() => [
                        _createTextVNode("失败")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: finishFun
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("搜索")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_table, {
        class: "components-table-demo-nested",
        columns: columns,
        "data-source": _unref(list),
        scroll: { y: 400 },
        pagination: false
      }, {
        bodyCell: _withCtx(({ column, record }) => [
          (column.dataIndex === 'Controls')
            ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                type: "primary",
                onClick: ($event: any) => (StatusQueryFun(record))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("查询状态")
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data-source"]),
      _createVNode(_component_a_pagination, {
        style: {"margin-top":"20px"},
        current: _unref(current),
        "onUpdate:current": _cache[3] || (_cache[3] = ($event: any) => (_isRef(current) ? (current).value = $event : current = $event)),
        simple: "",
        total: _unref(total),
        onChange: paginationChange,
        pageSize: 10,
        hideOnSinglePage: false
      }, null, 8, ["current", "total"])
    ]),
    _createVNode(_component_a_modal, {
      open: open.value,
      "onUpdate:open": _cache[4] || (_cache[4] = ($event: any) => ((open).value = $event)),
      width: "800px",
      title: "查询状态",
      onOk: handleOk,
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          columns: columnss,
          scroll: { y: 300 },
          pagination: false,
          "data-source": _unref(dataSource)
        }, null, 8, ["data-source"])
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})